import type { JSX } from 'react';
import { isEmpty } from 'lodash';
import { useMemo } from 'react';
import type { IServiceOrganizationSettings } from '@frontend/components/interfaces';
import { ServiceOrganizationSettings } from '@frontend/components/pages/organizations/serviceSettings/serviceOrganizationSetting/ServiceOrganizationSettings';
import { getServiceOrganizationRoles } from '@frontend/components/pages/organizations/serviceSettings/utils/serviceOrganizationRolesUtils';
import { ServiceOrganizationSetting } from './ServiceOrganizationSetting';
import { ServiceOrganizationSettingContext } from './serviceOrganizationSetting/ServiceOrganizationSettingsContext';

interface IServiceOrganizationSettingWrapperProps {
    reloadServiceOrganizationSettings: () => Promise<void>;
    serviceOrganizationSetting: IServiceOrganizationSettings;
}

export function ServiceOrganizationSettingWrapper(props: IServiceOrganizationSettingWrapperProps): JSX.Element {
    const serviceOrganizationRoles = useMemo(
        () => getServiceOrganizationRoles(props.serviceOrganizationSetting.service.code),
        [props.serviceOrganizationSetting.service.code]
    );

    const contextProviderValue = useMemo(() => {
        return {
            serviceOrganizationSetting: props.serviceOrganizationSetting,
            reloadServiceOrganizationSettings: props.reloadServiceOrganizationSettings,
        };
    }, [props.serviceOrganizationSetting, props.reloadServiceOrganizationSettings]);

    return (
        <ServiceOrganizationSettingContext.Provider value={contextProviderValue}>
            {!isEmpty(serviceOrganizationRoles) && (
                <ServiceOrganizationSettings serviceOrganizationRoles={serviceOrganizationRoles} />
            )}
            {isEmpty(serviceOrganizationRoles) && <ServiceOrganizationSetting />}
        </ServiceOrganizationSettingContext.Provider>
    );
}
